import { render, staticRenderFns } from "./BaseFieldLabel.vue?vue&type=template&id=7a81ff7b&"
import script from "./BaseFieldLabel.vue?vue&type=script&lang=js&"
export * from "./BaseFieldLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports